import React, { Component } from 'react';
import Header from './Header';
import Footer from './Footer';
import PropTypes from 'prop-types';
import { authService } from './../../Auth.service';

class Layout extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoggedIn: false
        };
        this.authService = new authService();
    }

    /**
     * Ui elements rendering
     */
    render() {
        let elements;
        if (!this.state.isLoggedIn) {
            elements = <div className="dummy"> {this.props.children}</div>
        } else {
            elements =
                <div className="dummy">
                    <Header />
                    {this.props.children}
                    <Footer />
                </div>
        }

        return (
            <div className="dummy">
                {elements}
            </div>
        )
    }

    /** 
     * Invoking on component mount
     * Getting login status for showing header and footer
     */
    componentDidMount() {
        this.subscription = this.authService.getLoginStatus().subscribe(status => {
            if (status) {
                this.setState({ isLoggedIn: true });
            } else {
                this.setState({ isLoggedIn: false });
            }
        });
    }

    /**
    * Invoking on component unmounting
    */
    componentWillUnmount() {
      if (this.subscription) this.subscription.unsubscribe();
    }
}

Layout.propTypes = {
    children: PropTypes.object.isRequired
};

export default Layout
